import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "manage-collaborators" }
const _hoisted_2 = { class: "manage-collaborators__subtitle" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "manage-collaborators__selection" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = {
  key: 0,
  class: "actions__public-link"
}
const _hoisted_7 = { class: "actions__slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Magnify = _resolveComponent("Magnify")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_NcListItemIcon = _resolveComponent("NcListItemIcon")!
  const _component_AccountGroup = _resolveComponent("AccountGroup")!
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")!
  const _component_NcPopover = _resolveComponent("NcPopover")!
  const _component_Close = _resolveComponent("Close")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_Check = _resolveComponent("Check")!
  const _component_ContentCopy = _resolveComponent("ContentCopy")!
  const _component_Earth = _resolveComponent("Earth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('memories', 'Add people or groups who can edit your album')), 1),
    _createElementVNode("form", {
      class: "manage-collaborators__form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_NcPopover, {
        shown: _ctx.showPopover,
        "auto-size": true,
        distance: 0,
        "focus-trap": false
      }, {
        trigger: _withCtx(({ attrs }) => [
          _createElementVNode("label", _mergeProps({ class: "manage-collaborators__form__input" }, attrs), [
            _createVNode(_component_NcTextField, {
              modelValue: _ctx.searchText,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
              autocomplete: "off",
              type: "search",
              name: "search",
              "aria-autocomplete": "list",
              label: _ctx.t('memories', 'Search for collaborators'),
              "aria-label": _ctx.t('memories', 'Search for collaborators'),
              "aria-controls": `manage-collaborators__form__selection-${_ctx.randomId} manage-collaborators__form__list-${_ctx.randomId}`,
              placeholder: _ctx.t('memories', 'Search people or groups'),
              onInput: _ctx.searchCollaborators
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Magnify, { size: 16 })
              ]),
              _: 1
            }, 8, ["modelValue", "label", "aria-label", "aria-controls", "placeholder", "onInput"]),
            (_ctx.loadingCollaborators)
              ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 0 }))
              : _createCommentVNode("", true)
          ], 16)
        ]),
        default: _withCtx(() => [
          (_ctx.searchResults.length !== 0)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                id: `manage-collaborators__form__list-${_ctx.randomId}`,
                class: "manage-collaborators__form__list"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (collaboratorKey) => {
                  return (_openBlock(), _createElementBlock("li", { key: collaboratorKey }, [
                    _createVNode(_component_NcListItemIcon, {
                      id: _ctx.availableCollaborators[collaboratorKey].id,
                      class: "manage-collaborators__form__list__result",
                      name: _ctx.availableCollaborators[collaboratorKey].label,
                      search: _ctx.searchText,
                      user: _ctx.availableCollaborators[collaboratorKey].id,
                      "display-name": _ctx.availableCollaborators[collaboratorKey].label,
                      "aria-label": 
                _ctx.t('memories', 'Add {collaboratorLabel} to the collaborators list', {
                  collaboratorLabel: _ctx.availableCollaborators[collaboratorKey].label,
                })
              ,
                      onClick: ($event: any) => (_ctx.selectEntity(collaboratorKey))
                    }, null, 8, ["id", "name", "search", "user", "display-name", "aria-label", "onClick"])
                  ]))
                }), 128))
              ], 8, _hoisted_3))
            : (_openBlock(), _createBlock(_component_NcEmptyContent, {
                key: "emptycontent",
                class: "manage-collaborators__form__list--empty",
                name: _ctx.t('memories', 'No collaborators available')
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_AccountGroup)
                ]),
                _: 1
              }, 8, ["name"]))
        ]),
        _: 1
      }, 8, ["shown"])
    ], 32),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listableSelectedCollaboratorsKeys, (collaboratorKey) => {
        return (_openBlock(), _createElementBlock("li", {
          key: collaboratorKey,
          class: "manage-collaborators__selection__item"
        }, [
          _createVNode(_component_NcListItemIcon, {
            id: _ctx.availableCollaborators[collaboratorKey].id,
            "display-name": _ctx.availableCollaborators[collaboratorKey].label,
            name: _ctx.availableCollaborators[collaboratorKey].label,
            user: _ctx.availableCollaborators[collaboratorKey].id
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NcButton, {
                variant: "tertiary",
                "aria-label": 
              _ctx.t('memories', 'Remove {collaboratorLabel} from the collaborators list', {
                collaboratorLabel: _ctx.availableCollaborators[collaboratorKey].label,
              })
            ,
                onClick: ($event: any) => (_ctx.unselectEntity(collaboratorKey))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_Close, { size: 20 })
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"])
            ]),
            _: 2
          }, 1032, ["id", "display-name", "name", "user"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.allowPublicLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.isPublicLinkSelected)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_NcButton, {
                    class: "manage-collaborators__public-link-button",
                    "aria-label": _ctx.t('memories', 'Copy the public link'),
                    disabled: _ctx.publicLink.id === '',
                    onClick: _ctx.copyPublicLink
                  }, {
                    icon: _withCtx(() => [
                      (_ctx.publicLinkCopied)
                        ? (_openBlock(), _createBlock(_component_Check, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_ContentCopy, { key: 1 }))
                    ]),
                    default: _withCtx(() => [
                      (_ctx.publicLinkCopied)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Public link copied!')), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Copy public link')), 1)
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "onClick"]),
                  _createVNode(_component_NcButton, {
                    variant: "tertiary",
                    "aria-label": _ctx.t('memories', 'Delete the public link'),
                    disabled: _ctx.publicLink.id === '',
                    onClick: _ctx.deletePublicLink
                  }, {
                    icon: _withCtx(() => [
                      (_ctx.publicLink.id === '')
                        ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_Close, { key: 1 }))
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "onClick"])
                ], 64))
              : (_openBlock(), _createBlock(_component_NcButton, {
                  key: 1,
                  class: "manage-collaborators__public-link-button",
                  onClick: _ctx.createPublicLinkForAlbum
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_Earth)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Share via public link')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default", { collaborators: _ctx.selectedCollaborators }, undefined, true)
      ])
    ])
  ]))
}